import api from "@/api/api";
import sampleFreeToolsResponse from "@/api/samples/freeTools";

export const getFreeToolsRubrics = (query = {}) => {
  return api.get("/rubrics", { params: { ...query, isUsedInFreeTools: true } });
};

export const freeToolGrade = async (payload) => {
  try {
    return api.post("/ai-tools/grade", payload);
  } catch (error) {
    return { data: sampleFreeToolsResponse };
  }
};

export const freeToolAiDetection = async (payload) => {
  return api.post("/ai-tools/ai-detection", payload);
};

export const freeToolAiSummary = async (payload) => {
  return api.post("/ai-tools/summary", payload);
};

export const createLetterOfRecommendation = (payload) => {
  return api.post("/ai-tools/letter-of-recommendation", payload);
};

export const createTongueTwisters = (payload) => {
  return api.post("/ai-tools/tongue-twister", payload);
};
